import { tEngine } from "../../i18n/engine";
import { t } from "../../i18n";
import { fmt, type LoadCaseResult } from "@tasduvar/engine";
import { useHighlight } from "../../state/highlight";

export function ForceTable({ c, cad }: { c: LoadCaseResult; cad?: boolean }): JSX.Element {
  const set = useHighlight((s) => s.set);
  return (
    <table className={`w-full text-[11px] num ${cad ? "border-collapse [&_td]:px-1 [&_th]:px-1 [&_tbody_tr]:border-b [&_tbody_tr]:border-cad-soft2" : ""}`} aria-label={t("Kuvvet tablosu")}>
      <thead><tr className={cad ? "bg-cad-head text-cad-ink2 font-semibold" : "text-stone"}><th className="text-left font-sans">{t("Kuvvet")}</th><th>V</th><th>H</th><th>x</th><th>y</th><th>{t("Mr")}</th><th>{t("Mo")}</th></tr></thead>
      <tbody>
        {c.forces.map((f) => (
          <tr key={f.id} aria-label={f.label} onMouseEnter={() => set(f.id)} onMouseLeave={() => set(null)} className="hover:bg-accent-light cursor-default">
            <td className="text-left font-sans truncate max-w-[9rem]" title={tEngine(f.label)}>{f.id} · {tEngine(f.label)}</td>
            <td>{fmt(f.V, 1)}</td><td>{fmt(f.H, 1)}</td><td>{fmt(f.armX, 2)}</td><td>{fmt(f.armY, 2)}</td><td>{fmt(f.Mres, 1)}</td><td>{fmt(f.Movr, 1)}</td>
          </tr>
        ))}
        <tr className="font-semibold border-t"><td className="text-left font-sans">Σ (N = {fmt(c.sums.N, 1)})</td><td>{fmt(c.sums.V, 1)}</td><td>{fmt(c.sums.Hdrive, 1)}</td><td /><td /><td>{fmt(c.sums.Mres, 1)}</td><td>{fmt(c.sums.Movr, 1)}</td></tr>
      </tbody>
    </table>
  );
}
